import './ItemDetail.css';

import React, { useState, useEffect } from "react";

// import { useCartContext } from '../../context/CartContext';
// import ItemCount from '../ItemCount';
import {Link } from 'react-router-dom';

export const Hw3ItemDetail = ({ data }) => {
    const [goToCart, setGoToCart] = useState(false);
    // const {addProduct} = useCartContext();
    // var portrait = true;

    // if (window.innerHeight > window.innerWidth) {
    //     portrait = true;
    // } else {
    //     portrait = false;
    // }

    const isLandscape = () => window.matchMedia('(orientation:landscape)').matches,
          [orientation, setOrientation] = useState(isLandscape() ? 'landscape' : 'portrait'),
          onWindowResize = () => {              
            clearTimeout(window.resizeLag)
            window.resizeLag = setTimeout(() => {
              delete window.resizeLag                       
              setOrientation(isLandscape() ? 'landscape' : 'portrait')
            }, 200)
          }

    useEffect(() => (
      onWindowResize(),
      window.addEventListener('resize', onWindowResize),
      () => window.removeEventListener('resize', onWindowResize)
    ),[])

    function Landscape() {
        return (
            // style={{ width: 50%,}}
            <div className="contenido_h">
            {/* <div className="detail_landscape"> */}
                <div className="detalle_h1">
                    <img className="detail__image_landscape" src={data.image} alt=""/>
                </div>
                {/* <div className="content"> */}
                <div className="detalle_h2">
                    <h1>{data.title}</h1>
                    <p>Precio u.: {data.price}</p>
                   <p>Categoria: {data.category}</p>
                </div>
            {/* </div> */}
            </div>
           )
      }

      function Portrait() {
        return (
        //   <div
        //     style={{
            //   height: 60,
            //   backgroundColor: "lightgray",
            //   color: "black",
            //   display: "flex",
            //   justifyContent: "center",
            //   alignItems: "center",
            //   fontWeight: "bold",
        //     }}
        //   >
        <div className="contenido_v">
        {/* <div className="detail_landscape"> */}
        <div className="detalle_v1">
                <img className="detail__image_portraid" src={data.image} alt=""/>
            </div>
            {/* <div className="content"> */}
            <div className="detalle_v2">
                <h1>{data.title}</h1>
                <p>Precio u.: {data.price}</p>
               <p>Categoria: {data.category}</p>
            </div>
        {/* </div> */}
        </div>
    );
      }

    return (
        <div className="container">
            <p>Screen orientation portrait is: {orientation}</p>
            {/* <div className="contenido"> */}
            {orientation==="landscape" && ( <Landscape/>
                //   <img className="detail__image_landscape" src={data.image} alt=""/>
              )}
              {orientation==="portrait" && ( <Portrait/>
                // <img className="detail__image_portraid" src={data.image} alt="" />
              )}
                {/* <div className="content">
                    <h1>{data.title}</h1>
                    <p>Precio u.: {data.price}</p>
                    <p>Categoria: {data.category}</p>
                </div> */}
            {/* </div>   */}
        </div>
    );
}

export default Hw3ItemDetail;